const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};
export const capitalizeTheFirstLetterOfEachWord = (sentence) => {
    return sentence
        .toLowerCase()
        .split(' ')
        .map((word) => capitalizeFirstLetter(word))
        .join(' ');
};
export const getHostname = (url) => {
    const hostnameArray = /\/\/([a-zA-Z0-9.]*)/m.exec(url);
    return (hostnameArray && hostnameArray[1]) || '';
};
export const sanitiseContactNumber = (contactNumber) => contactNumber.replace(/\s+/g, '').replace(/[()]/g, '');
// we are only UK for now so…
export const internationaliseContactNumber = (contactNumber) => sanitiseContactNumber(contactNumber).replace(/^0/, '+44');
export const formatDate = (d) => new Date(d).toLocaleString('en-GB', {
    year: 'numeric',
    month: 'short',
});
export const formatArrayToString = (arr) => {
    if (arr.length === 0) {
        return undefined;
    }
    else if (arr.length === 1) {
        return arr[0];
    }
    else {
        const lastElement = arr[arr.length - 1];
        const restElements = arr.slice(0, arr.length - 1);
        const restElementsString = restElements.join(', ');
        return `${restElementsString} and ${lastElement}`;
    }
};
